import { useQuery } from "@tanstack/react-query";
import getTags from "api/tags/getTags";
import { tagsListKey } from "queryKeys/tagsList";

export default function useGetTagsList() {
  return useQuery({
    queryKey: tagsListKey(),
    queryFn: getTags,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
